<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { insertIntoTextArea1 } from "@common/Common";
    import { AlternativesViewReadModel, AttributeReadModel } from '@Evaluation/Estimations/Domain/readmodels';
    import { PanelAlternativesManagerSaveEventPayload, PanelAlternativesManagerViewModel } from "@Evaluation/Estimations/Components/PanelAlternativesManager";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class PanelAlternativesManager extends Vue
    {
        get vm(): PanelAlternativesManagerViewModel { return this.$props.viewModel as PanelAlternativesManagerViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get alternativesLabel(): string { return this.vm.alternativesLabel; }        
        get attributes(): AttributeReadModel[] { return this.vm.attributes; }
        get views(): AlternativesViewReadModel[] { return this.vm.views; }
        get emailAttributes(): AttributeReadModel[] { return this.vm.emailAttributes; }

        get descriptionTemplate(): string { return this.vm.descriptionTemplate; }
        set descriptionTemplate(val: string) { this.vm.descriptionTemplate = val; }

        get viewDefId(): string | null { return this.vm.viewDefId; }
        set viewDefId(val: string | null) { this.vm.viewDefId = val; }

        get attributeId(): number | null { return this.vm.attributeId; }
        set attributeId(val: number | null) { this.vm.attributeId = val; }

        insert(txtToAdd: string)
        {
            insertIntoTextArea1(this.$refs.ta as HTMLTextAreaElement, txtToAdd);
            (this.$refs.ta as any).dispatchEvent(new Event('input'));
        }

        save()
        {
            const payload = new PanelAlternativesManagerSaveEventPayload(this.vm.surveyId, this.descriptionTemplate, this.viewDefId, this.attributeId);
            this.$emit('save', payload);
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content" style="height: calc(100vh - 50px);">
                    <div class="modal-header">
                        <h5 class="modal-title">Manage <span class="text-lowercase">{{alternativesLabel}}</span></h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div class="form-group">
                            <label>List:</label>
                            <select v-model="viewDefId" class="form-control">
                                <option :value="null">All</option>
                                <option v-for="v in views" :value="v.Id">{{v.Name}}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Filter by attribute:</label>
                            <select v-model="attributeId" class="form-control">
                                <option :value="null">No selection</option>
                                <option v-for="attr in emailAttributes" :value="attr.AttributeId">{{attr.Name}}</option>
                            </select>
                        </div>

                        <div>
                            <div class="d-flex justify-content-end">
                                <div class="dropdown">
                                    <button class="btn btn-sm btn-secondary dropdown-toggle" data-toggle="dropdown">Insert</button>
                                    <div class="dropdown-menu dropdown-menu-right" style="overflow-y: auto; max-height: 400px;">
                                        <a class="dropdown-item" @click="insert('{Description}')">Description</a>
                                        <a class="dropdown-item" @click="insert('{Status}')">Status</a>

                                        <a class="dropdown-item" v-for="attr in attributes" :key="attr.AttributeId" @click="insert(`{${attr.Name}}`)">
                                            {{attr.Name}}
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <textarea ref="ta" rows="5" v-model.trim="descriptionTemplate" class="form-control" />
                                <small class="form-text text-muted"></small>
                            </div>

                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="save" type="button" class="btn btn-primary">Save &amp; Close</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>